import { render, staticRenderFns } from "./Browser.vue?vue&type=template&id=f253855e&scoped=true&"
import script from "./Browser.vue?vue&type=script&lang=js&"
export * from "./Browser.vue?vue&type=script&lang=js&"
import style0 from "./Browser.vue?vue&type=style&index=0&id=f253855e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f253855e",
  null
  
)

export default component.exports